module.exports = __webpack_public_path__ + "media/images/icons/icons_small/52_key-c7f7ed01e9936f65c97eb57d281db660.png";